<template>
  <div id="app">
  <AnnualRuns msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import AnnualRuns from "./components/AnnualRuns.vue";

export default {
  name: 'App',
  components: {
    AnnualRuns
  }
}
</script>
<style lang="scss">
#app {
    display:block;
}
</style>
